var React = require('react');

function Linkedin (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"iconmonstr-linkedin-3","className":"to-be-filled","d":"M24.608,0H6.476A6.477,6.477,0,0,0,0,6.476V24.608a6.477,6.477,0,0,0,6.476,6.476H24.608a6.476,6.476,0,0,0,6.476-6.476V6.476A6.476,6.476,0,0,0,24.608,0ZM10.361,24.608H6.476V10.361h3.885ZM8.419,8.719a2.285,2.285,0,1,1,2.267-2.285A2.276,2.276,0,0,1,8.419,8.719ZM25.9,24.608H22.018V17.35c0-4.362-5.181-4.032-5.181,0v7.258H12.952V10.361h3.885v2.286C18.645,9.3,25.9,9.051,25.9,15.854Z","fill":"#fafafa"}));
}

Linkedin.defaultProps = {"width":"31.084","height":"31.084","viewBox":"0 0 31.084 31.084"};

module.exports = Linkedin;

Linkedin.default = Linkedin;
